import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import './ToolPage.css'
import { fetchFileShareInfo, fileShareDownloadUrl } from './utils/fileShareApiClient'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const formatSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`
}

const FileShareDownload = () => {
  useDocumentMeta({
    title: 'Baixar Arquivo Compartilhado | jarder.dev',
    description: 'Confira os detalhes do arquivo antes de baixar.',
  })

  const { id } = useParams()
  const [info, setInfo] = useState(null)
  const [status, setStatus] = useState('loading')
  const [downloaded, setDownloaded] = useState(false)

  useEffect(() => {
    let cancelled = false
    fetchFileShareInfo(id).then((data) => {
      if (cancelled) return
      if (data) {
        setInfo(data)
        setStatus('ready')
      } else {
        setStatus('notfound')
      }
    })
    return () => {
      cancelled = true
    }
  }, [id])

  const download = () => {
    window.location.href = fileShareDownloadUrl(id)
    setDownloaded(true)
    trackEvent('tool_copy', { tool: 'file_share_download' })
  }

  if (status === 'loading') {
    return (
      <div className="tool-page">
        <p>Carregando...</p>
      </div>
    )
  }

  if (status === 'notfound') {
    return (
      <div className="tool-page">
        <Link to="/ferramentas/compartilhar-arquivo" className="tool-back-link">
          ← Todas as ferramentas
        </Link>
        <h1>Arquivo não encontrado</h1>
        <p className="tool-disclaimer">Esse link não existe, já expirou ou atingiu o limite de downloads.</p>
        <Link to="/ferramentas/compartilhar-arquivo" className="tool-button">
          Compartilhar um novo arquivo
        </Link>
      </div>
    )
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Baixar Arquivo Compartilhado</h1>
      <p className="tool-disclaimer">
        Confira se você reconhece quem te mandou esse link antes de baixar.
      </p>

      <div className="tool-result-card">
        <span className="tool-result-label">Arquivo</span>
        <span className="tool-result-value">{info.originalName}</span>
      </div>

      <p className="tool-import-hint">
        {formatSize(info.size)} — {info.downloadsRemaining} download(s) restante(s) antes de expirar
      </p>

      <button type="button" className="tool-button" onClick={download} style={{ marginTop: 12 }}>
        Baixar arquivo
      </button>

      {downloaded && (
        <p className="tool-import-hint" style={{ marginTop: 12 }}>
          Se o download não começou, o link já pode ter atingido o limite. Atualize a página pra conferir.
        </p>
      )}
    </div>
  )
}

export default FileShareDownload
